// app/javascript/packs/application.js
console.log("Webpacker is running");

import Rails from "@rails/ujs";
Rails.start();

import "stylesheets/application"  // Adjust path if you’re using SCSS or CSS


document.addEventListener("DOMContentLoaded", () => {
  const flashes = document.querySelectorAll('[data-behavior="flash"]');

  flashes.forEach(flash => {
    // Auto-hide after 15 seconds
    setTimeout(() => {
      flash.style.transition = "opacity 0.5s ease-out";
      flash.style.opacity = "0";
      setTimeout(() => flash.remove(), 500);
    }, 15000);

    // Manual close button
    const closeBtn = flash.querySelector(".flash-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        flash.style.transition = "opacity 0.3s ease-out";
        flash.style.opacity = "0";
        setTimeout(() => flash.remove(), 300);
      });
    }
  });
});

